module.exports = __webpack_public_path__ + "img/mobilexpense.5368a8e6.svg";